import {
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  PLATFORM_ID,
  Renderer2,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { IDataCategory, IDataCategoryValue } from '../../../../interfaces/IDataCategory';
import { Router } from '@angular/router';
import { DataCategoryService } from '../../../services/data-category.service';
import {ClientSideRenderingDirective} from '../../../../../../common/directives/client-side-rendering.directive';

@Component({
  selector: 'ra-category-menu',
  standalone: true,
  imports: [CommonModule, ButtonModule, ClientSideRenderingDirective],
  templateUrl: './category-menu.component.html',
  styleUrl: './category-menu.component.scss',
})
export class CategoryMenuComponent {
  @Input() dataCategory!: IDataCategory[][];
  @Input() currentIndex!: number;
  @Input() mapStatusOpenedMenu!: Map<string, boolean>;
  @Input() isOpened!: boolean;
  @Input() amountCol!: number;
  @Output() handleOpened = new EventEmitter<void>();

  readonly array = Array;
  readonly math = Math;

  constructor(
    private _renderer: Renderer2,
    @Inject(PLATFORM_ID) private _platformId: object,
    private router: Router,
    private dataCategoryService: DataCategoryService
  ) {}

  redirectToPage(group: IDataCategory, menu?: IDataCategoryValue) {
    this.handleStatusOpened();

    const queryParams: Record<string, string> = {};

    let currentUrl = '';

    if (this.currentIndex === 0 || this.currentIndex === 1) {
      currentUrl = `https://rentag.ru/${this.currentIndex ? 'arenda-spectehniki' : 'arenda-avto'}/poisk`;
      queryParams['vehicleGroupId'] = group.id?.toString() || '';
      queryParams['sort'] = 'publishdateutc_desc';

      if (menu) {
        queryParams['bodyTypeId'] = menu.id.toString();
      }
    } else {
      if (group.type.toLocaleLowerCase() === 'арендовать') {
        currentUrl = `https://rentag.ru/lk/estate/requests/new/${menu ? menu.linkCre : ''}`;
      } else {
        currentUrl = `https://rentag.ru/lk/estate/offers/new/${menu ? menu.linkCre : ''}`;
      }
    }
    // Создаем строку параметров запроса
    const queryString = new URLSearchParams(queryParams).toString();

    // Заменяем текущий URL с использованием window.location.replace
    window.open(`${currentUrl}?${queryString}`, '_blank');
  }

  selectTab(index: number) {
    if (this.currentIndex === index) return;

    this.currentIndex = index;
    this.mapStatusOpenedMenu.clear();
  }

  handleStatusOpened(e?: Event): void {
    if (e) e.stopPropagation();

    if (this.isOpened) this.mapStatusOpenedMenu.clear();
    this.handleClassBody();

    this.handleOpened.emit();
  }

  handleClassBody() {
    if (isPlatformBrowser(this._platformId)) {
      const body = document.body;

      !this.isOpened
        ? this._renderer.addClass(body, 'overflow-hidden')
        : this._renderer.removeClass(body, 'overflow-hidden');
    }
  }

  setNewValue(type: string) {
    const value = !this.mapStatusOpenedMenu.get(type);
    this.mapStatusOpenedMenu.set(type, value);
  }

  getMenu(rowIndex: number, colIndex: number) {
    return this.dataCategory[this.currentIndex][rowIndex * this.amountCol + colIndex];
  }
}
